import { commitApi } from '@/api/commitApi'
import { draftApi } from '@/api/draftApi'
import type { CommitDetail } from '@/api/types'
import { arrayToKeyed, type MetadataV2 } from '@/services/metadata/keyed'
import type { ProjectMetadataV1 } from '@/services/metadata/schema'
import { diffToOps } from '@/stores/draftStore'

export async function syncDraftMetadata(
  projectId: number,
  metadata: ProjectMetadataV1,
): Promise<{ baseCommitId: number | null; rev: number }> {
  const draft = await draftApi.get(projectId)
  const current = draft.metadata as MetadataV2
  const next = arrayToKeyed(metadata)
  const ops = diffToOps(current, next)

  if (ops.length === 0) {
    return {
      baseCommitId: draft.base_commit,
      rev: draft.rev,
    }
  }

  const saved = await draftApi.applyOps(
    projectId,
    { baseRev: draft.rev, ops },
    { silent: true },
  )

  return {
    baseCommitId: draft.base_commit,
    rev: saved.rev,
  }
}

export async function createCommitFromMetadata(
  projectId: number,
  metadata: ProjectMetadataV1,
  commit: {
    name: string
    description?: string
  },
): Promise<CommitDetail> {
  const { baseCommitId } = await syncDraftMetadata(projectId, metadata)
  return commitApi.create(
    projectId,
    {
      name: commit.name,
      description: commit.description ?? '',
      base_commit_id: baseCommitId,
    },
    { silent: true },
  )
}
